import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  componentWillUnmount
} from "react";
import { Paper, Button, Typography, FormControlLabel } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Button as AntdButton, Dropdown, message, Space, Tooltip } from "antd";
import useStyles from "@/styles/groupsStyle";
import { useDebounceEffect } from "ahooks";
import { deviceModifyAPI } from "@/apis/deviceModifyAPI";
import HasPermission from "@/components/commons/HasPermission";
import SingleSelector from "@/components/SingleSelector";
import SearchInput from "@/components/SearchInput";
import { IconDevices } from "@/components/Icon";
import { FormItem } from "@/components/Form";
import { useTranslation } from "@/langs/useTranslation";
import {
  getCurrentCompanyId,
  useGlobalDispatch,
  useGlobalState
} from "@/GlobalProvider";
import { toast } from "@/helpers/toast";
import { useGroupDeviceDispatch, useGroupDeviceState } from "./Provider";
import modalConfirm from "@/components/Modal/modalConfirm";
// 更新状态弹窗
import UpdateVersionModal from "./UpdateVersionModal";
// 注册弹窗
import RegisterModal from "./RegisterModal";
// 指派弹窗
import SelectCompanyTreeModal from "./SelectCompanyTreeModal";
import SelectStoreTreeModal from "./SelectStore/SelectStoreTreeModal";
import ImportCompanyDeviceDialog from "./Category/Import/ImportDialog";

// 上传excel弹窗,进行指派、注册和删除
import UpdateImportCompanyDeviceDialog from "./UpdateImport/ImportDialog";

import _ from "lodash";

import StoreApi from "@/apis/storeAPI";
import localforage from "localforage";

import DeviceTableList from "./DeviceTableList";
import TagList from "./TagList";
import CompanyDeviceApi from "@/apis/companyDeviceApi";

import DeviceDetailModal from "./DeviceDetailModal";
import { downloadBlob } from "@/helpers/utils";
import { removeDevice } from "@/apis/apiCollection";
import RemoveModal from "./RemoveModal";

const DeviceList = () => {
  const { t } = useTranslation("dashboard");

  const classes = useStyles();
  // 刷新分类
  const { reloadCategoryTree } = useGroupDeviceDispatch();

  // 查看
  const [DeviceDetailStatus, SetDeviceDetailStatus] = useState({
    open: false,
    os_type: "",
    rowData: null
  });
  // 指派
  const [AssignModalState, SetAssignModalState] = useState({
    open: false,
    type: 1, // 1 根据选择框 2 // 单行
    rowData: {}
  });
  // 注册
  const [RegisterModalState, SetRegisterModalState] = useState({
    open: false,
    type: 1, // 1 根据选择框 2 // 单行
    rowData: {}
  });
  // 修改版本
  const [UpdateVersionModalState, SetUpdateVersionModalState] = useState({
    open: false,
    type: 1, // 1 根据选择框 2 // 单行
    rowData: {}
  });
  // 移除设备
  const [RemoveModalState, SetRemoveModalState] = useState({
    open: false,
    type: 1, // 1 根据选择框 2 // 单行
    rowData: {}
  });

  const [openImportDialog, setOpenImportDialog] = useState({
    open: false,
    type: "Windows",
    title: ""
  });

  // 上传弹窗
  const [openUpdateImportDialog, setOpenUpdateImportDialog] = useState({
    open: false,
    type: "Windows",
    title: ""
  });

  const [crossType, setCrossType] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loadingTable, setLoadingTable] = useState(null);

  // prettier-ignore
  const { loadingGroup, currentTag, filterBy, filterByMode,currentGroup } = useGroupDeviceState();
  const { setShowDetail } = useGlobalDispatch();

  const { location, push } = useHistory();

  const query = useMemo(
    () =>
      new URLSearchParams(location.search || (filterByMode ? filterBy : "")),
    [location.search, filterByMode, filterBy]
  );
  // 使用 ahooks 库，将状态存储在 localStorage 中的 Hook
  // https://ahooks.js.org/zh-CN/hooks/use-local-storage-state
  // const [lastGroupQueryParams, setLastGroupQueryParams] = useLocalStorageState(
  //   "__lastGroupQueryParams",
  //   { defaultValue: {} }
  // );

  // prettier-ignore
  const initialValues = {
    status: '',
    group_ids: [],
    tag_ids: [],
    searchValue: "",
    os_type: '',
    nubis_version: ''
  };
  // 使用 formik 库 https://formik.bootcss.com/api/useFormik.html
  const formik = useFormik({
    initialValues,
    onSubmit: values => {
      setCheckedAll(false);
      setSelectedRowKeys([]);
      pageSetting.page = 1;
      reloadTableData();
    },
    onReset: values => {
      pageSetting.page = 1;
      // pageSetting.page_size = 20
      pageSetting.order_by_column = null;
      pageSetting.order_by_desc = null;
      setSelectedRowKeys([]);
      setCheckedAll(false);
      setTimeout(() => {
        reloadTableData("rest");
      }, 0);
    }
  });

  const importHandler = async event => {
    // let res = await deviceModifyAPI("group", currentGroupId, undefined);
    // if (res) {
    //   setTaskSchedule(res);
    setOpenImportDialog({
      open: true,
      type: event.key,
      title:
        t({ defaultMessage: "上传" }) +
        " " +
        event.key +
        " " +
        t({ defaultMessage: "设备" })
    });
    // }
  };

  const updateImportHandler = async event => {
    // let res = await deviceModifyAPI("group", currentGroupId, undefined);
    // if (res) {
    //   setTaskSchedule(res);
    const label = updateMenuProps.items.find(
      item => item.key === event.key
    ).label;
    setOpenUpdateImportDialog({
      open: true,
      type: event.key,
      title: label
    });
    // }
  };

  const resetQuery = () => {
    formik.handleReset({
      values: initialValues
    });
  };

  const handleExport = async () => {
    //
    const user_company_id = await localforage.getItem("userCompanyID");
    const company_id =
      currentGroup && currentGroup.id !== "all" ? currentGroup.id : null;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const res = await CompanyDeviceApi.Export({
      company_id: user_company_id,
      check_company_ids: company_id ? [company_id] : null,
      status: formik.values.status,
      search_value: formik.values.searchValue,
      group_ids: formik.values.group_ids ? formik.values.group_ids : [],
      tag_ids: formik.values.tag_ids ? formik.values.tag_ids : [],
      os_type: formik.values.os_type,
      nubis_version: formik.values.nubis_version,
      selectedRowKeys: selectedRowKeys,
      timeZone: timeZone
    }).then(response => {
      toast.success(response.message);
    });

    // downloadBlob(res, "company-device-export.xlsx");
    // downloadBlob(res, "company_device.xlsx");

    // const token = await localforage.getItem("token");
    // $.ajax({
    //   url: `${url}/api/v2/devices/dataTables/download`,
    //   method: "GET",
    //   contentType: "application/json",
    //   dataSrc: "data",
    //   data: queryParams.current,
    //   xhrFields: {
    //     responseType: "blob" // Set the response type to blob
    //   },
    //   beforeSend: request => {
    //     request.setRequestHeader("Authorization", "Bearer " + token);
    //     request.setRequestHeader("Accept", "application/json");
    //   },
    //   success: function (response) {
    //     downloadBlob(response, "devices_datatables.xlsx");
    //   },
    //   error: err => {
    //     errorHandling(err);
    //   }
    // });
  };

  // 修改设备版本确认
  const handleUpdateVersionConfirm = async value => {
    let deviceIds = selectedRowKeys;
    // 行操作
    if (UpdateVersionModalState.type === 2) {
      deviceIds = [UpdateVersionModalState.rowData.device_id];
    }
    const res = await CompanyDeviceApi.UpdateDeviceVersion(value, deviceIds);
    if (res && res.message === "success") {
      setSelectedRowKeys([]);
      reloadTableData();
      toast.success(t({ defaultMessage: "操作成功" }));
    }

    SetUpdateVersionModalState({
      type: 1,
      rowData: {},
      open: false
    });
  };

  // 注册确认
  const handleRegisterConfirm = async () => {
    let deviceIds = selectedRowKeys;
    // 行操作
    if (RegisterModalState.type === 2) {
      deviceIds = [RegisterModalState.rowData.device_id];
    }
    const res = await CompanyDeviceApi.DeviceRegister(deviceIds);
    if (res && res.message === "success") {
      setSelectedRowKeys([]);
      reloadTableData();
      reloadCategoryTree();
      toast.success(t({ defaultMessage: "操作成功" }));
    }
    SetRegisterModalState({
      type: 1,
      rowData: {},
      open: false
    });
  };

  // 指派确认
  const handleAssignConfirm = async company_ids => {
    let deviceIds = selectedRowKeys;
    // 行操作
    if (AssignModalState.type === 2) {
      deviceIds = [AssignModalState.rowData.device_id];
    }
    const res = await CompanyDeviceApi.DeviceAssign(company_ids, deviceIds);
    if (res && res.message === "success") {
      setSelectedRowKeys([]);
      reloadTableData();
      reloadCategoryTree();
      toast.success(t({ defaultMessage: "操作成功" }));
    }
    SetAssignModalState({
      type: 1,
      rowData: {},
      open: false
    });
  };

  // 移除确认
  const handleRemoveConfirm = async () => {
    let deviceIds = selectedRowKeys;
    // 行操作
    if (RemoveModalState.type === 2) {
      deviceIds = [RemoveModalState.rowData.device_id];
    }
    try {
      await removeDevice({ deviceIds });
      reloadTableData();
      reloadCategoryTree();
      toast.success(t({ defaultMessage: "操作成功" }));
    } catch (e) {}
    SetRemoveModalState({
      type: 1,
      rowData: {},
      open: false
    });
  };

  useEffect(() => {
    // console.log("----------currentGroup--------", currentGroup);
    pageSetting.page = 1;
    if (currentGroup) reloadTableData();
  }, [currentGroup]);

  const importMenuProps = {
    items: [
      {
        label: t({ defaultMessage: "上传Windows设备" }),
        key: "windows"
      },
      {
        label: t({ defaultMessage: "上传Android设备" }),
        key: "android"
      },
      {
        label: t({ defaultMessage: "上传Linux设备" }),
        key: "linux"
      }
    ],
    onClick: importHandler,
    trigger: "click"
  };

  const updateMenuProps = {
    items: [
      {
        label: t({ defaultMessage: "批量指派设备" }),
        key: "assign"
      },
      {
        label: t({ defaultMessage: "批量注册设备" }),
        key: "register"
      },
      {
        label: t({ defaultMessage: "批量删除设备" }),
        key: "remove"
      }
    ],
    onClick: updateImportHandler,
    trigger: "click"
  };

  const reloadTableData = async type => {
    const user_company_id = await localforage.getItem("userCompanyID");
    const company_id = currentGroup ? currentGroup.id : null;
    const requestParams = {
      company_id: user_company_id,
      check_company_ids:
        company_id && company_id !== "all" ? [company_id] : null,
      // check_company_ids: ['83a53790-aaf0-4c3e-b605-f1702c5004cb'],
      start:
        pageSetting.page <= 0
          ? 0
          : (pageSetting.page - 1) * pageSetting.page_size,
      length: pageSetting.page_size,
      status: formik.values.status,
      search_value: formik.values.searchValue,
      group_ids: formik.values.group_ids ? formik.values.group_ids : [],
      tag_ids: formik.values.tag_ids ? formik.values.tag_ids : [],
      os_type: formik.values.os_type,
      nubis_version: formik.values.nubis_version,
      order_by_column: pageSetting.order_by_column,
      order_by_desc: pageSetting.order_by_desc === "ascend" ? "asc" : "desc"
    };
    if (type === "rest") {
      requestParams.start = 0;
      requestParams.length = 20;
      requestParams.search_value = "";
      requestParams.status = "";
      requestParams.group_ids = [];
      requestParams.tag_ids = [];
      requestParams.os_type = "";
      requestParams.nubis_version = "";
      requestParams.order_by_column = null;
      requestParams.order_by_desc = null;
    }
    const res = await CompanyDeviceApi.GetDevicesList(requestParams);
    const data = res.data;
    setPageSetting({
      ...pageSetting,
      total: res.recordsTotal
    });

    setTotalCount(res.recordsTotal);
    setTableData(data);
    setTableLoading(false);
  };
  // table ref
  const tableRef = useRef(null);
  // 列表多选
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // table loading
  const [tableLoading, setTableLoading] = useState(true);
  // 数据总数
  const [tableCount, setTableCount] = useState(0);
  // 分页相关
  // const [pageSetting,setPageSetting] = useLocalStorageState("__pageSetting",{
  //   defaultValue: {
  //     page:0,
  //     page_size: 20,
  //     total: 0,
  //     sort:{} // 排序相关
  //   },
  //   listenStorageChange: false
  // })
  const [pageSetting, setPageSetting] = useState({
    page: 1,
    page_size: 20,
    total: 0,
    order_by_column: null, // 排序相关
    order_by_desc: null
  });

  // table data
  const [tableData, setTableData] = useState([]);

  // 是否全选
  const [checkedAll, setCheckedAll] = useState(false);

  // 排序相关
  // const [tableOrder,setTableOrder] = useState({
  //   order_by_column: pageSetting.sort.order_by_column,
  //   order_by_desc: pageSetting.sort.order_by_desc
  // })

  const tableFunc = {
    // 查看设备详情
    handleDetail: data => {
      SetDeviceDetailStatus({
        open: true,
        os_type: data.os_type,
        rowData: data
      });
    },

    // 操作栏指派
    handleAssign: data => {
      SetAssignModalState({
        type: 2,
        rowData: data,
        open: true
      });
    },

    // 操作栏注册
    handleRegister: data => {
      SetRegisterModalState({
        type: 2,
        rowData: data,
        open: true
      });
    },

    // 操作栏修改版本
    handleEditVersion: data => {
      SetUpdateVersionModalState({
        type: 2,
        rowData: data,
        open: true
      });
    },

    // 操作栏移除设备
    handleRemove: data => {
      SetRemoveModalState({
        type: 2,
        rowData: data,
        open: true
      });
    },

    handleStoreEdit: data => {
      setShowDetail(true, data.id, "edit");
    },

    handleStoreDel: data => {
      modalConfirm({
        title: t({ defaultMessage: "提示信息" }),
        content: t({ defaultMessage: "确定要删除吗？" }),
        onConfirm: async () => {
          const companyId = await getCurrentCompanyId();
          StoreApi.Remove(data.id, companyId);
        }
      });
    },
    // 排序，分页等等
    onChange: (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
      pageSetting.order_by_column = null;
      pageSetting.order_by_desc = null;
      if (sorter.column) {
        pageSetting.order_by_column = sorter.field;
        // pageSetting.order_by_desc = sorter.order === 'descend' ? 'desc' : 'asc'
        pageSetting.order_by_desc = sorter.order;
      }
      pageSetting.page = pagination.current;
      pageSetting.page_size = pagination.pageSize;
      reloadTableData();
    },
    // 多选
    onSelectChange: newSelectedRowKeys => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
    // 全选
    handleChangeCheckedAll: async e => {
      setCheckedAll(e.target.checked);
      if (!e.target.checked) {
        setSelectedRowKeys([]);
        return;
      }
      // 需要获取到全部的table列表数据
      const user_company_id = await localforage.getItem("userCompanyID");
      const company_id = currentGroup ? currentGroup.id : null;
      const res = await CompanyDeviceApi.GetDevicesList({
        company_id: user_company_id,
        check_company_ids:
          company_id && company_id !== "all" ? [company_id] : null,
        // check_company_ids: ['83a53790-aaf0-4c3e-b605-f1702c5004cb'],
        start: 0,
        length: 999999999,
        status: "",
        search_value: "",
        group_ids: [],
        tag_ids: [],
        os_type: "",
        nubis_version: ""
      });
      const data = res.data;
      _.each(data, item => {
        if (!_.includes(selectedRowKeys, item.device_id)) {
          selectedRowKeys.push(item.device_id);
        }
      });
      setSelectedRowKeys(_.cloneDeepWith(selectedRowKeys, true));
    },
    // 修改版本弹窗
    handleOpenUpdateVersionModal: () => {
      if (selectedRowKeys.length <= 0) {
        toast.info(t({ defaultMessage: "未选择设备" }));
        return;
      }
      SetUpdateVersionModalState({
        open: true,
        rowData: {},
        type: 1
      });
    },

    // 注册弹窗
    handleOpenRegisterModal: () => {
      if (selectedRowKeys.length <= 0) {
        toast.info(t({ defaultMessage: "未选择设备" }));
        return;
      }
      SetRegisterModalState({
        open: true,
        rowData: {},
        type: 1
      });
    },
    // 指派弹窗
    handleOpenAssignModal: () => {
      if (selectedRowKeys.length <= 0) {
        toast.info(t({ defaultMessage: "未选择设备" }));
        return;
      }
      SetAssignModalState({
        type: 1,
        open: true,
        rowData: {}
      });
    },
    // 移除设备弹窗
    handleOpenRemoveModal: () => {
      if (selectedRowKeys.length <= 0) {
        toast.info(t({ defaultMessage: "未选择设备" }));
        return;
      }
      SetRemoveModalState({
        type: 1,
        open: true,
        rowData: {}
      });
    }
  };

  // 导入门店成功 刷新当前页面
  const handleImportSuccess = () => {
    reloadTableData();
  };
  // useEffect(() => {
  //   if (query.size) {
  //     setFilterBy(query.toString());
  //   }
  // }, [location.search]);

  // useUpdateEffect(() => {
  //   if (!filterByMode) {
  //     push(location.pathname);
  //   }
  // }, [filterByMode]);

  // useDebounceEffect(
  //   () => {
  //     if (currentGroup || currentTag || filterBy) {
  //       resetQuery();
  //     }
  //   },
  //   [currentGroup && currentGroup.id, currentTag, filterBy, currentCompanyId],
  //   { wait: 20 }
  // );
  return (
    <div className={classes.main}>
      <div className={`${classes.tableAction} company-device-list-action`}>
        <HasPermission permission="device_and_groups_export">
          <Button
            variant="outlined"
            className={classes.iconWText}
            onClick={handleExport}
          >
            {t({ defaultMessage: "导出" })}
          </Button>
        </HasPermission>
        {currentGroup && currentGroup.id != "all" && (
          <Dropdown menu={updateMenuProps} className={`import-menu`}>
            <AntdButton size="default">
              <Space>
                {t({ defaultMessage: "更新设备" })}
                <DownOutlined />
              </Space>
            </AntdButton>
          </Dropdown>
        )}
        <HasPermission permission="device_and_groups_import">
          {currentGroup && currentGroup.id != "all" && (
            <Dropdown menu={importMenuProps} className={`import-menu`}>
              <AntdButton size="default">
                <Space>
                  {t({ defaultMessage: "上传设备" })}
                  <DownOutlined />
                </Space>
              </AntdButton>
            </Dropdown>
          )}
        </HasPermission>
      </div>
      <Paper
        elevation={0}
        className={`${classes.deviceInGroup} company-device-list-paper`}
      >
        <form onSubmit={formik.handleSubmit}>
          <FormItem style={{ marginBottom: 12 }}>
            <div className={classes.tableTop}>
              {filterByMode ? (
                <div>
                  <div className={classes.queryKeyword}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      component="span"
                    >
                      {t({ defaultMessage: "查询结果：" })}
                    </Typography>
                    <Typography variant="body1" component="span">
                      <IconDevices color="primary" style={{ marginRight: 5 }} />
                      {totalCount}
                      {t({ defaultMessage: "台" })}
                    </Typography>
                  </div>
                  <div className={classes.queryKeyword}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      component="span"
                    >
                      {t({ defaultMessage: "查询条件：" })}
                    </Typography>
                    <Typography variant="body1" component="span"></Typography>
                  </div>
                </div>
              ) : (
                <div>
                  <>
                    <span className={classes.groupName}>
                      {currentGroup && currentGroup.name}
                    </span>
                    <span className={classes.groupCount}>
                      <IconDevices color="primary" style={{ marginRight: 5 }} />
                      {totalCount}
                      {t({ defaultMessage: "台" })}
                    </span>
                  </>
                </div>
              )}
              {!filterByMode && (
                <SearchInput
                  placeholder={t({ defaultMessage: "搜索" })}
                  name="searchValue"
                  icon={null}
                  disabled={crossType === 2}
                  value={formik.values.searchValue}
                  onChange={formik.handleChange}
                  onPressEnter={formik.handleSubmit}
                />
              )}
            </div>

            <div className={`${classes.tableQueryForm} tableQueryForm`}>
              <div className={"search-box-left"}>
                {t({ defaultMessage: "状态" })}
              </div>
              <SingleSelector
                placeholder={t({ defaultMessage: "全部" })}
                options={[
                  { name: t({ defaultMessage: "未激活" }), id: "inactive" },
                  { name: t({ defaultMessage: "已激活" }), id: "activated" },
                  { name: t({ defaultMessage: "已注册" }), id: "registered" }
                ]}
                clearable
                disabled={crossType === 2}
                name="status"
                initialValue=""
                value={formik.values.status}
                onChange={formik.handleChange}
              />
              {/* <div className={"search-box-left"}>
                {t({ defaultMessage: "Nubis版本" })}
              </div>
              <SingleSelector
                placeholder={t({ defaultMessage: "全部" })}
                options={[
                  { name: "Pro", id: "nubis_pro" },
                  { name: "Free", id: "nubis_free" }
                ]}
                clearable
                disabled={crossType === 2}
                name="nubis_version"
                initialValue=""
                value={formik.values.nubis_version}
                onChange={formik.handleChange}
              /> */}
              {currentGroup && currentGroup.id !== "all" && (
                <>
                  <div className={"search-box-left"}>
                    {t({ defaultMessage: "门店" })}
                  </div>
                  <div className="up-store-box">
                    <SelectStoreTreeModal
                      checkStrictly
                      name="group_ids"
                      value={formik.values.group_ids}
                      style={{ height: "auto" }}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className={"search-box-left"}>
                    {t({ defaultMessage: "标签" })}
                  </div>
                  <div className="tag-box">
                    <TagList
                      disabled={crossType === 2}
                      name="tag_ids"
                      value={formik.values.tag_ids}
                      onChange={formik.handleChange}
                      currentGroup={currentGroup}
                    />
                  </div>
                </>
              )}

              <div className={"search-box-left"}>
                {t({ defaultMessage: "设备类型" })}
              </div>
              <SingleSelector
                placeholder={t({ defaultMessage: "全部" })}
                options={[
                  { name: "Android", id: "android" },
                  { name: "Windows", id: "windows" },
                  { name: "Linux", id: "linux" }
                ]}
                clearable
                disabled={crossType === 2}
                name="os_type"
                initialValue=""
                value={formik.values.os_type}
                onChange={formik.handleChange}
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={crossType === 2}
                style={{ marginRight: 16, padding: "6px 16px" }}
              >
                {t({ defaultMessage: "查询" })}
              </Button>
              <Button
                variant="outlined"
                disabled={crossType === 2}
                onClick={() => resetQuery(true)}
              >
                {t({ defaultMessage: "重置" })}
              </Button>
            </div>
          </FormItem>
          {/*<FormItem>*/}
          {/*  <div className={`tableQueryForm tableQueryForm-last`}>*/}

          {/*  </div>*/}
          {/*</FormItem>*/}
        </form>
        <div
          className={`${classes.tableWrap} company-device-table-list paltform-antd-table`}
          style={{ visibility: loadingGroup || loadingTable ? "hidden" : "" }}
        >
          <DeviceTableList
            ref={tableRef}
            tableLoading={tableLoading}
            pageSetting={pageSetting}
            selectedRowKeys={JSON.parse(JSON.stringify(selectedRowKeys))}
            checkedAll={checkedAll}
            tableData={tableData}
            tableFunc={tableFunc}
          />
        </div>

        <UpdateVersionModal
          open={UpdateVersionModalState.open}
          onClose={() =>
            SetUpdateVersionModalState({ open: false, rowData: {} })
          }
          onConfirm={handleUpdateVersionConfirm}
        />

        <RegisterModal
          open={RegisterModalState.open}
          onClose={() => SetRegisterModalState({ open: false, rowData: {} })}
          onConfirm={handleRegisterConfirm}
        />

        <RemoveModal
          open={RemoveModalState.open}
          onClose={() => SetRemoveModalState({ open: false, rowData: {} })}
          onConfirm={handleRemoveConfirm}
        />

        <SelectCompanyTreeModal
          open={AssignModalState.open}
          onClose={() => SetAssignModalState({ open: false, rowData: {} })}
          onConfirm={handleAssignConfirm}
        />

        <ImportCompanyDeviceDialog
          title={openImportDialog.title}
          type={openImportDialog.type}
          open={openImportDialog.open}
          groupId={""}
          onSuccess={handleImportSuccess}
          onClose={() => setOpenImportDialog({ open: false })}
        />

        <UpdateImportCompanyDeviceDialog
          title={openUpdateImportDialog.title}
          type={openUpdateImportDialog.type}
          open={openUpdateImportDialog.open}
          groupId={""}
          onSuccess={handleImportSuccess}
          onClose={() => setOpenUpdateImportDialog({ open: false })}
        />

        <DeviceDetailModal
          open={DeviceDetailStatus.open}
          onConfirm={() => SetDeviceDetailStatus({ open: false })}
          os_type={DeviceDetailStatus.os_type}
          rowData={DeviceDetailStatus.rowData}
          onClose={() => SetDeviceDetailStatus({ open: false })}
        />
      </Paper>
    </div>
  );
};

export default DeviceList;
